import { registerLateDibsSessionDatadog } from '../src/utils/lateDibsSession.ts';

registerLateDibsSessionDatadog();

export { datadog } from '../src/datadog.ts';
export {
    initSharedDatadogRum,
    pdpTypes,
    initDatadogRum,
    sbTypes,
    homeTypes,
} from '../src/utils/init.ts';
export { pushDatadogView, popDatadogView } from '../src/utils/datadogStack.ts';
export { setDatadogUserValues, setDatadogSessionValues } from '../src/utils/setDatadogValues.ts';
